import es_routes from "./route_translations/es_routes";

const es = {
  ...es_routes,
  back: "Atrás",
  close: "Cerrar",
  play: "Play",
  resume: "Reanudar",
  load_more: "Ver Más",
  more_info: "Más información",
  content_text: "Mira a {artist} en FlixLatino por solo $3.99",
  detail_page: {
    subscribe: "Suscribirse ahora",
    trailer: "Tráiler",
    about: "Acerca de",
    country: "País de origen: ",
    directors: "Dirigido por: ",
    cast: "Elenco: ",
    next_episodes: "Próximos episodios",
    view_all_episodes: "Ver todos los episodios",
    episodes: "Episodios",
    similar_content: "Contenido Similar",
    season: "Temporada",
    play: "Reproducir",
    watch_and_stream_movies: "{movie} {'|'} Ver películas online",
    watch_episode_alt:
      "Reproducir {episode} en línea {'|'} Reproducir {show} Temporada {season}",
    stream_tv_shows: "{title} {'|'} Series de TV online",
    next_episode_alt:
      "Reproducir {show} en línea {'|'} Reproducir temporada {season}, {episode}",
    next_episode_title: "Temporada {season}, {episode}",
  },
  home: {
    meta: {
      title: "Series y Películas en Español - FlixLatino - Cine en Español",
      description:
        "FlixLatino ofrece las mejores películas y series en español del mundo habla-hispano, con cine latino y entretenimiento para toda la familia. Descubre incontables horas de cine hispano, las series más recientes y programación de tu país, todo sin comerciales por tan solo 3.99 al mes. Tu cultura, tus películas.",
    },
  },
  browse: {
    meta: {
      title: "Explorar contenido",
      description:
        "Explora la colección más grande de entretenimiento en Español. Suscríbete para una prueba gratis hoy.",
    },
  },
  discover: {
    meta: {
      title: "Descubre Películas y Series en Español en Línea | FlixLatino",
      description:
        "Disfruta la colección más grande de entretenimiento en Español. Descubre las películas y series por genero o por países. Suscríbete para una prueba gratis hoy.",
    },
    title: "Descubre",
    subtitle: "Descubre entretenimiento en español <br /> de todo el mundo",
    search: "Buscar películas, series de televisión, actores, géneros...",
    by_country: {
      view_all: "Ver todos",
      content_from: "Contenido de {country}",
      result_count: "{count} Resultados",
      title: "Navegar contenido por país",
      subtitle:
        "¡Selecciona un país de interés y encuentra todas las mejores películas y programas de televisión en español producidos allí!",
    },
    moods: {
      title: "Descubre películas según tu estado de ánimo",
      subtitle:
        "¡Selecciona un estado de ánimo y encuentra todas las mejores películas y programas de televisión en español que coincidan con tu estado de ánimo!",
      trynow: "Probar ahora",
    },
  },
  checkout: {
    locale: "es_ES",
    loading: "Conectando...",
    card: {
      number: "Número de tarjeta",
      expiration: "Fecha de vencimiento",
      cvc: "CVC",
      postal: "Zip Code",
      cardholderName: "Nombre del titular de la tarjeta",
    },
    mobile: {
      change_plan: "Cambiar plan",
      title: "Prueba 7 Días",
      sub_title: "Monto a pagar hoy: ${amount}*",
      confirm: "Comenzar Prueba Gratis",
      free_trial: "Prueba Gratis",
      free_trial_dias: "7 Días Gratis",
      smalltext:
        "Al presionar el botón de “Comenzar Prueba Gratis”, aceptas nuestros términos y condiciones y certificas que eres mayor de 18 años. Puedes cancelar en cualquier momento durante tu prueba gratis y no serás cobrado. Para cancelar diríjase a las preferencias de su cuenta y presione “Cancelar Membresía”.",
      condition:
        "Se pre autorizará un monto de $0.01 para validar su tarjeta de crédito el cual será regresado en su totalidad en las próximas 24 horas.",
      bullets: {
        one: "Configurar pago para más tarde",
        two: "Gratis hasta {date}",
        three: "Monto a cobrar después de la prueba ${price}",
      },
      plans: {
        basic: "FlixLatino Básico",
        premium: "FlixLatino Premium",
        monthly: "Mensual",
        annual: "Anual",
      },
    },
    title: "Pagar",
    title_trial: "Prueba 7 Días",
    subtitle: "Confirma y comienza tu prueba gratuita de 7 días.",
    firstname: "Nombre",
    lastname: "Apellido",
    credit: "Número de tarjeta de crédito/débito",
    exp: "Vencimiento (MM/AA)",
    cvv: "Código de seguridad (CVV)",
    giftcode: "Introducir código de regalo",
    plan_details: "Ver detalles del plan",
    confirm: "Confirmar",
    free_trial: "Prueba gratuita",
    validating: "Validando...",
    notvalid: "Código no válido",
    willbecharged: "Se te cobrará el",
    sevendays: "7 días gratis",
    duetoday: "Pagar hoy:",
  },
  body_promo: {
    title: "Más de 1000 horas de entretenimiento en español",
    subtitle:
      "Las series turcas más populares, películas y series de México, España, Colombia, Venezuela, República Dominicana, Perú y más.",
    button: "Comienza tu prueba gratuita",
  },
  register: {
    title: "Crea tu cuenta",
    subtitle: "¡Comencemos creando tu cuenta para acceder a tu membresía!",
    email: "Correo electrónico",
    password: "Contraseña",
    confirm_password: "Confirmar contraseña",
    continue: "Continuar",
    account: "Cuenta",
    payment: "Pago",
    account_exists: "Esta dirección de correo electrónico ya está registrada",
    password_not_match: "Las contraseñas no coinciden",
    password_missing: "Se requiere una contraseña",
  },
  message: {
    hello: "hola mundo",
  },
  navbar: {
    trial: "Inicia Tu Prueba gratis",
    discover: "Descubre",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    subscribe: "Suscribirse ahora",
    currentLanguage: "ES",
    lang: {
      es: "ES",
      en: "EN",
    },
    logged: {
      movies: "Peliculas",
      series: "Series",
      live: "FlixLive",
      my_list: "Mi Lista",
      by_country: "Por pais",
      preferences: "Cuenta",
      help: "Ayuda",
    },
  },
  plans: {
    title: "Elige tu plan",
    subtitle:
      "Disfruta de una prueba gratis al ...ccionas un plan. Actualiza o cancela* en cualquier momento.",
    toggle: {
      monthly: "Mensual",
      annual: "Anual",
    },
    includes: "el plan incluye",
    most_popular: "MÁS POPULAR",
    buttons: {
      monthly: {
        basic: "Suscribirse por $3.99",
        premium: "Suscribirse ahora por $4.99",
      },
      annual: {
        basic: "Suscribirse por $35.99",
        premium: "Suscribirse ahora por $44.99",
      },
    },
    basic: {
      title: "Contenido bajo demanda para todos",
      button_title: "FLIXLATINO",
      description:
        "Comienza con todas tus películas y programas de TV favoritos bajo demanda para ti y toda tu familia por solo $3.99",
      bullets: [
        ["Películas, series y animados para niños", "positive"],
        ["Estrenos semanales (Martes, Jueves, Sábados)", "positive"],
        ["Programación en Alta Definición (HD), sin comerciales", "positive"],
        ["Canales en vivo", "positive"],
        ["Perfil para niños (FlixKids)", "positive"],
        ["Cancela cuando quieras", "positive"],
        ["4 pantallas simultáneas (Solo 2)", "negative"],
        ["Todos los episodios por adelantado (Estrenos semanales)", "negative"],
        ["Descargas disponibles", "negative"],
      ],
    },
    premium: {
      title: "Disfruta de tu contenido favorito donde quiera que estés",
      button_title: "Flixlatino Premium",
      description:
        "Descarga contenido para ver sin conexión y maratona estrenos completos de temporadas.",
      bullets: [
        ["Películas, series y animados para niños", "positive"],
        ["Estrenos semanales (Martes, Jueves, Sábados)", "positive"],
        ["Programación en Alta Definición (HD), sin comerciales", "positive"],
        ["Canales en vivo", "positive"],
        ["Perfil para niños (FlixKids)", "positive"],
        ["Cancela cuando quieras", "positive"],
        ["4 pantallas simultáneas", "positive"],
        ["Todos los episodios por adelantado", "positive"],
        ["Descargas disponibles", "positive"],
      ],
    },
  },
  login: {
    title: "Iniciar sesión",
    remember: "Recordarme",
    email: "Dirección de correo electrónico",
    password: "Contraseña",
    forgot: "¿Olvidaste tu contraseña?",
    continue: "Continuar",
    donthave: "¿No tienes una cuenta?",
    create: "Crear cuenta",
  },
  landing: {
    miff: {
      title: "Para los amantes del buen cine",
      map_title: "Películas, series y animados",
    },
    slider: {
      title: "Tu cultura, <br> tus películas",
      emailPlaceholder: "Ingresa correo electrónico",
      startTrial: "Comienza tu prueba gratuita",
      value_1: "Sin comerciales",
      value_2: "Series y películas en español",
      value_3: "Hasta 4 dispositivos al mismo tiempo",
    },
    premieres: {
      title: "Estrenos",
      browse_all: "Ver todo el contenido",
    },
    exclusive_content: {
      title: "Exclusivo para FlixLatino",
    },
    promo: {
      title: "Disponible en tu plataforma favorita",
      featured_actors: "Actores destacados",
      featured_actors_on: "{actor} en FlixLatino",
      featured_actors_desc:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Facilisi ornare sed pretium arcu id laoreet arcu, lectus non.",
      whatch_on_tv: "Mira en TV",
      whatch_on_tv_desc:
        "Mira tu contenido favorito en tu Samsung Smart TV, Roku, AppleTV, AndroidTV, Amazon FireTV y Chromecast.",
      use_our_app: "Descarga nuestra aplicación",
      use_our_app_desc:
        "Disfruta de películas, series y dibujos animados para toda la familia, donde quieras. ¡Descarga nuestra aplicación y comienza a disfrutar hoy mismo!",
    },
    testimonials: {
      title: "Testimonios",
      member_since: "Miembro desde {date}",
      message: "{message_es}",
    },
    our_products: {
      title: "Nuestros planes",
      plans: "Ver detalles del plan",
      plan_1: {
        plan: "FlixLatino Basic",
        title: "Contenido bajo demanda para todos",
        description:
          "Comienza con todas tus películas y programas de TV favoritos bajo demanda para ti y toda tu familia por solo $3.99",
        button: "Suscribirse por $3.99",
      },
      plan_2: {
        plan: "FlixLatino Premium",
        title: "Disfruta de tu contenido favorito donde quiera que estés",
        description:
          "Descarga contenido para ver sin conexión y maratona estrenos completos de temporadas.",
        button: "Suscribirse ahora por $4.99",
      },
    },
    be_part_of: {
      title: "Únete a FlixLatino",
      subtitle:
        "Suscríbete y disfruta de las mejores series y películas en español",
      emailPlaceholder: "Ingresa correo electrónico",
      startTrial: "Comienza tu prueba gratuita",
    },
    language: {
      current: "Español",
      current_code: "es",
      other: "Inglés",
      other_code: "en",
    },
  },
  profiles: {
    add: "Añadir",
    add_title: "Añadir perfil",
    whoiswatching: "¿Quién está viendo?",
    done: "Hecho",
    manage: "Administrar perfiles",
    logout: "Cerrar sesión",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar perfil",
    name: "Nombre (Requerido)",
    email: "Correo electrónico",
    country: "País de origen",
    birthday: "Fecha de nacimiento",
    language: "Idioma",
    flixKids: {
      title: "FlixLatino Kids",
      description:
        "Un perfil de FlixKids solo reproducirá programas de televisión y películas cuidadosamente seleccionados para niños, y no permitirá acceder a la configuración de la cuenta.",
    },
  },
  search: {
    search: "Buscar",
    placeholder: "Buscar películas, series, actores, etc.",
    search_results: "Resultados de búsqueda para",
    search_results_empty: "No se encontraron resultados para",
    search_results_empty_suggestion: "Prueba a buscar un término diferente",
    countries: "Países",
    categories: "Categorías",
    actors: "Actores",
    genres: "Géneros",
    directors: "Directores",
    deafult_title: "Recomendado",
    results: "Resultados",
    no_results: "No se encontraron resultados",
  },
  preferences: {
    access_until: "Tienes acceso hasta",
    membersince: "Miembro desde",
    billing: "Facturación",
    billing_date: "Tu próxima fecha de facturación es ",
    plan_details: "Detalles del plan",
    cancel_membership: "Cancelar membresía",
    change_password: "Cambiar contraseña",
    change_number: "Cambiar número",
    manage_subscription: "Administrar suscripción",
    change_plan: "Cambiar plan",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    wrong_password: "Contraseña incorrecta",
    password_success: "Contraseña actualizada",
    save_payment_method: "Guardar método de pago",
  },
  floatingmenu: {
    browse: "Navega",
    movies: "Peliculas",
    series: "Series y shows",
    live: "FlixLive",
    my_list: "Mi lista",
    countries: "Por país",
  },
  forgotpassword: {
    title: "¿Olvidaste tu contraseña?",
    sent_title: "Correo electrónico enviado",
    email_required: "Correo electrónico requerido",
    email_sent:
      "Hemos enviado a tu dirección de correo electrónico las instrucciones para restablecer tu contraseña.",
  },
  cancel: {
    title: "Por favor, indícanos por qué deseas cancelar tu membresía.",
    sub_title:
      "Selecciona una opción a continuación para proceder con la cancelación de tu membresía.",
    reason_a: "No estoy satisfecho/a con el contenido en FlixLatino",
    reason_b: "FlixLatino es demasiado caro para mí",
    reason_c: "No tengo tiempo para ver FlixLatino",
    reason_d: "Demasiado almacenamiento en búfer o mala calidad de video",
    reason_e: "Otra",
    cancel_success: "Tu membresía ha sido cancelada",
  },
  link: {
    title: "Vincular dispositivo",
    code: "Código",
    continue: "Continuar",
    success: "Dispositivo vinculado",
  },
  meta: {
    about: {
      title: "Sobre Nosotros - FlixLatino",
      description:
        "FlixLatino es un servicio de entretenimiento en español por Internet \"Over The Top\" (OTT) en la modalidad de aplicación, que entrega contenidos bajo el sistema de 'subscription video-on-demand' (SVOD) para el mercado hispano de los Estados Unidos y Puerto Rico en todas las plataformas y productos electrónicos.",
    },
    movie: {
      title: "Ver {title} Online {'|'} FlixLatino",
      description:
        "Ver {title} online. Ver la película completa usando su computadora o dispositivo móvil y compartela con amigos. Únete a FlixLatino.",
    },
    series: {
      title: "Ver {title} Online {'|'} FlixLatino",
      description:
        "Ver {title} online. Ver la serie completa usando su computadora o dispositivo móvil y compártela con amigos.",
    },
    episodes: {
      title:
        "Ver {show} en línea: Temporada {season}, {episode} {'|'} FlixLatino",
      description:
        "Ver todos los episodios de {show} online. Ver Temporada {season}, {episode} en línea usando su computadora o dispositivo móvil y compártela con amigos.",
    },
  },
  termsAndConditions: {
    meta: {
      title: "Condiciones de uso - FlixLatino",
      description:
        "Somos un servicio por subscripción que provee acceso a películas, programas de televisión y demás contenido audio visual transmitidos a través del Internet",
    },
  },
  about_us: "{es}",
  footer: {
    discover: "Descubre",
    movies: "Películas",
    contactUs: "Contáctanos",
    news: "Blog",
    search: "Buscar",
    faq: "FAQ",
    aboutUs: "Quiénes Somos",
    privacyPolicy: "Política de privacidad",
    termsAndConditions: "Términos y condiciones",
    callUs: "Llámenos gratis al",
  },
  "Get the full experience!": "¡Obtén la experiencia completa!",
  "Start your free trial now to get unlimited content":
    "Comienza tu prueba gratis y disfruta de tu contenido favorito",
  "Free Trial": "Prueba gratis",
  Trending: "Tendencias",
  "Top Movies in 2024": "Mejores Películas 2024",
  "Top Movies Right Now": "Mejores Películas Ahora",
  "Top TV Shows in 2024": "Mejores Series de TV 2024",
  "Top TV Shows Right Now": "Mejores Series de TV Ahora",
};
export default es;
